import { Action, createReducer, on } from '@ngrx/store';
import { commonAtcActions } from './atc.action';
import { CommonAtcState, commonAtcIS } from './atc.state';

const commonAtcRegister = createReducer(
  commonAtcIS,

  on(commonAtcActions.setPagedResultAction, (state, { result }) => ({
    ...state,
    result,
  })),

  on(commonAtcActions.setListResultAction, (state, { result: plain }) => ({
    ...state,
    plain,
  })),

  on(
    commonAtcActions.setMedicineResultAction,
    (state, { result: medicines }) => ({
      ...state,
      medicines,
    })
  ),

  on(commonAtcActions.addMedicineResultAction, (state, medicine) => ({
    ...state,
    medicines: [...state.medicines, medicine],
  })),

  on(commonAtcActions.setAllDefaultAction, () => commonAtcIS)
);

export function commonAtcReducer(state: CommonAtcState, action: Action): any {
  return commonAtcRegister(state, action);
}
